import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { fmtDate } from "@/lib/helpers";
import { FilePlus2, Search } from "lucide-react";

export default function BuyerRFQs() {
  const [rfqs, setRfqs] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/rfqs").then((r) => setRfqs(r.data)).catch(() => {});
  }, []);

  const filtered = rfqs.filter((r) => r.title.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="p-6 md:p-8 max-w-7xl">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="label-tech text-muted-foreground mb-1">Request history</div>
          <h1 className="text-3xl font-bold tracking-tight">My RFQs</h1>
        </div>
        <Link to="/buyer/new-rfq" data-testid="rfqs-new-button" className="inline-flex items-center gap-2 px-5 py-2.5 bg-brand text-white rounded-sm hover:bg-brand-dark transition-colors">
          <FilePlus2 className="h-4 w-4" /> New RFQ
        </Link>
      </div>

      <div className="mt-6 relative max-w-sm">
        <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input data-testid="rfq-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search RFQs…"
          className="w-full border border-input bg-card pl-9 pr-3 py-2.5 rounded-sm text-sm outline-none focus:border-brand transition-colors" />
      </div>

      <div className="mt-6 border border-border rounded-sm overflow-hidden bg-card">
        <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-3 border-b border-border label-tech text-muted-foreground bg-secondary/50">
          <div className="col-span-5">Part</div>
          <div className="col-span-2">Process</div>
          <div className="col-span-1 text-center">Qty</div>
          <div className="col-span-1 text-center">Quote</div>
          <div className="col-span-1">Date</div>
          <div className="col-span-2 text-right">Status</div>
        </div>
        {filtered.length === 0 && <div className="px-5 py-12 text-center text-sm text-muted-foreground">No RFQs found.</div>}
        {filtered.map((r) => (
          <Link key={r.id} to={`/rfqs/${r.id}`} data-testid={`rfq-row-${r.id}`} className="grid grid-cols-2 md:grid-cols-12 gap-2 md:gap-4 px-5 py-4 border-b border-border last:border-0 items-center hover:bg-secondary/50 transition-colors">
            <div className="col-span-2 md:col-span-5 min-w-0">
              <div className="font-medium truncate">{r.title}</div>
              <div className="text-xs font-mono text-muted-foreground truncate md:hidden">{r.process} · Qty {r.quantity}</div>
            </div>
            <div className="hidden md:block col-span-2 text-sm text-muted-foreground truncate">{r.process}</div>
            <div className="hidden md:block col-span-1 text-center text-sm font-mono">{r.quantity}</div>
            <div className="hidden md:block col-span-1 text-center text-sm font-mono">{r.has_customer_quote ? "Ready" : "—"}</div>
            <div className="hidden md:block col-span-1 text-xs text-muted-foreground">{fmtDate(r.created_at)}</div>
            <div className="col-span-2 flex justify-end"><StatusBadge status={r.status} /></div>
          </Link>
        ))}
      </div>
    </div>
  );
}
